export enum AccessLevel {
  read = 'read',
  edit = 'edit',
  no_access = 'no_access'
}
